<!-- <ng-container *ngIf="cargando">
  <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
  </div>
</ng-container> -->

<div class="p-20" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
  <ng-container *ngIf="!sinAdic">
    <h2 style="text-align:center;" *ngIf="preguntas.length == 0">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.SIN' | translate}}</h2>
    <h2 style="text-align:center;" *ngIf="preguntas.length > 0">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.CON' | translate}} {{preguntas.length}}</h2>

    <div cdkDropList (cdkDropListDropped)="drop($event)">

      <ng-container *ngFor="let pregunta of preguntas; let i = index; let last = last; let first = first;">
        <div cdkDrag>
          <mat-icon aria-hidden="false" class="mr-20" matTooltip="" style="display:none" cdkDragHandle>menu</mat-icon>
          <preguntaAdicional
            [idPreg]="pregunta.iterador"
            [productoCertificar]="productoCertificar"
            [idiomas]="idiomas"
            [datosPregunta]="pregunta.datosPregunta"
            [iterPregunta]="i"
            [pasoCompleto]="pasoCompleto"
            (idPreguntaBorrar)="borrarPregunta($event)"
            (mensajeSnack)="mensajeSnack($event)"
            (mensajeSwal)="mensajeSwal($event)"
          >
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          </preguntaAdicional>

        </div>
      </ng-container>

    </div>
    <!------------------------>

    <div *ngIf="pasoCompleto" fxLayout="row" fxLayoutAlign="center center" style="padding:20px 0px;">
      <h2 class="pr-20">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.ACCIONES.ADD' | translate}}</h2>
      <button mat-fab color="primary" aria-label="agregaPreg" (click)="agregaPregunta()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>
  </ng-container>

  <ng-container *ngIf="sinAdic">
    <h2 style="text-align:center;">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.NOADICIONALES' | translate}}</h2>
  </ng-container>


  <div fxLayout="row" fxLayoutAlign="center center" style="padding:20px 0px;" *ngIf="preguntas.length == 0">
    <mat-checkbox (click)="sinAdicionales($event)" [(ngModel)]="idSinAdic"><h2>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.ACCIONES.SIN' | translate}}</h2></mat-checkbox>
  </div>


</div>
